const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const TranslationAdd = () => import(/* webpackChunkName: "translation" */ './view/add.vue');
const TranslationExport = () => import(/* webpackChunkName: "translation" */ './view/export.vue');
const TranslationList = () => import(/* webpackChunkName: "translation" */ './view/index.vue');
const TranslationTranslate = () => import(/* webpackChunkName: "translation" */ './view/translate.vue');

export const ROUTE_NAME_TRANSLATION = {
    INDEX: 'TranslationList',
    ADD: 'TranslationAdd',
    EDIT: 'TranslationEdit',
    TRANSLATE: 'TranslationTranslate',
    EXPORT: 'TranslationExport'
} as const;

export default [
    {
        path: '/app/:appId/translation',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'export',
                name: ROUTE_NAME_TRANSLATION.EXPORT,
                component: TranslationExport,
                meta: { requiresAuth: true }
            },
            {
                path: 'item',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_TRANSLATION.INDEX,
                        component: TranslationList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_TRANSLATION.ADD,
                        component: TranslationAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_TRANSLATION.EDIT,
                        component: TranslationAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/translate',
                        name: ROUTE_NAME_TRANSLATION.TRANSLATE,
                        component: TranslationTranslate,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
